var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.682 31.277c-10.546 0-13.364-10.993-12.09-18.196a.357.357 0 0 1 .645-.14c.555.814 1.048 1.991 1.866 1.89 1.229-.154 2.08-10.997 9.363-14.048a.323.323 0 0 1 .447.336c-.36 3.533 1.762 8.592 5.52 8.592 2.154 0 3.629-1.72 4.365-3.447.224-.524.99-.458 1.119.097 1.314 5.693 4.828 24.916-11.235 24.916Z",
    fill: "#FF8F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.985 20.677a.419.419 0 0 1 .68.253c.132.747.566 2.03 1.987 2.03 1.71 0 2.87-4.704 3.174-6.088a.431.431 0 0 1 .5-.336c4.272.869 6.35 14.741-3.044 14.741-6.838 0-5.29-8.927-3.297-10.6ZM24.659 5.653c.15-1.177-2 2.044-2 2.044s1.64.774 2-2.044ZM2.997 23.216c.045-.501-.6-1.844-.714-1.312-.274 1.271.668 1.813.714 1.312Z",
    fill: "#FFB636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.198 21.787c-.16-.668-.734.884-.662 1.516.072.632 1.046.083.662-1.516Z",
    fill: "#FFD469"
  })));
};
export default SvgFire;